import {useEffect, useRef} from "react";
import useCalc from "@/hooks/calculator.ts";
import useLoans from "@/hooks/loans.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import useAuth from "@/hooks/auth.ts";
import useNotifications from "@/hooks/notifications.ts";
import {useAtom} from "jotai/index";
import {open_notifications_sidebar} from "@/atoms/profile.ts";
import {get_technical} from "@/services/notifications.ts";
import {useLocation} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";


const AuthInits = () => {
    const calc = useCalc()
    const loans = useLoans()
    const visible_ref = useRef<boolean>(true)
    const auth = useAuth()
    const effect_ran = useRef<boolean>(false)
    const notif = useNotifications()
    const [openNotifications] = useAtom(open_notifications_sidebar)
    const count_set = useRef(false)
    const interval_ref = useRef<any>(null)
    const location = useLocation()
    
 
    
    const clear_states = () => {
        loans.clearLoanApplications()
        loans.clearCredits()
        // notif.clearNotifications()
        if(openNotifications) {
            notif.notification_sidebar_handle()
        }
        
        // clearInterval(interval_ref.current)
    }

    const reset_states = async () => {
        calc.update_calculator_limits()
        loans.updPendingLoans()
        notif.update_count()
        notif.updatePaginatedNotifications()
        loans.updateUserLoans()
        // clearInterval(interval_ref.current)
        eventEmitter.emit(CommonClass.CustomEvents.switch_doc_reader, "")
    }
    

    useEffect(() => {

        const getProducts = async () => {
            notif.update_count()
            await get_technical()
            count_set.current = true
        }
        
        
        if(!effect_ran.current) {
            getProducts()
        }
        
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                if(!visible_ref.current) {
                    auth.auth_ping()
                }
                
            } else {
                if(visible_ref.current) visible_ref.current = false
            }
        };
        
        document.addEventListener('visibilitychange', handleVisibilityChange);
        eventEmitter.on(CommonClass.CustomEvents.clear_states, clear_states)
        eventEmitter.on(CommonClass.CustomEvents.reset_states, reset_states)
        
        return () => {
            effect_ran.current = true
            clearInterval(interval_ref.current)
            eventEmitter.off(CommonClass.CustomEvents.clear_states, clear_states)
            eventEmitter.off(CommonClass.CustomEvents.reset_states, reset_states)
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
        
    }, [])
    
    useEffect(() => {
        if(!location.pathname.includes("promotions")){
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
        
        if (location.pathname !== DashboardClass.dashboard_routes.Locations && location.pathname !== DashboardClass.dashboard_routes.ApplyCredit && !location.pathname.includes("/office/")) {
            localStorage.removeItem(CommonClass.local_storage_fields.reserve_data);
        }
        
    }, [location.pathname]);
    
    return <></>
}


export default AuthInits
